import styled, { css } from 'styled-components';
import { colors } from '../../layout/design';
import { ToastContainer } from 'react-toastify';
import { CheckMarkCircle, InfoCircle, XCircle } from '@assets/images/index';

export const baseTyping = css`
  font-family: 'futura-pt', sans-serif;
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  line-height: 24px;
`;

export const Container = styled.div``;
export const InsertText = styled.span`
  ${baseTyping}
`;
export const BlueText = styled.span`
  ${baseTyping}
  padding-left: 15px;
  color: ${colors.blue};
`;

const StyledToastContainer = styled(ToastContainer)`
  --toastify-toast-width: 480px;
  --toastify-toast-min-height: 56px;
  .Toastify__toast--default {
    color: ${colors.darkGrey};
  }
  .Toastify__toast--success {
    color: ${colors.green};
  }
  .Toastify__toast--error {
    color: ${colors.error};
  }
  .Toastify__close-button {
    align-self: center;
    margin-right: 10px;
  }
`;

export const StyledCheckCircle = styled(CheckMarkCircle)`
  width: 15px;
`;

export const StyledInfoCircle = styled(InfoCircle)`
  width: 15px;
  path {
    fill: ${colors.grey};
  }
`;

export const StyledXCircle = styled(XCircle)`
  width: 15px;
  path {
    fill: ${colors.error};
  }
`;

export default StyledToastContainer;
